// import projectDH from '../assets/projects/project_dh.png'
import projectPF from '../assets/projects/project_portfolio.png'
import projectEC from '../assets/projects/project_ec.png'

export const data=[
    {
        id:1,
        name:"Einbürgerung Coach",
        description:"Interactive German citizenship test preparation app with AI-powered explanations (beta), quiz modes, and progress tracking built with React and Web LLM integration.",
        image:projectEC,
        projectOrigin:"Personal",
        github:"https://github.com/RBCodewalker/einbuergerung-coach",
        live:"https://einbuergerung-coach.vercel.app/",
    },
    {
        id:2,
        name:"U.S. Election Coverage",
        description:"US Election coverage live map using D3, with high-traffic interactive state-level reporting.",
        imageName:"us.png",
        projectOrigin:"Axel Springer",
        live:"https://www.bild.de/ig/699ff606-1d74-4d9f-80f9-95d4105767a2/index/index.html#/client/2024/state",
    },
    {
        id:3,
        name:"Bundestagswahl Coverage - Map",
        description:"Interactive live map  for Bundestagswahl coverage, with all 299 state candidate face-offs.",
        imageName:"btw-m.png",
        projectOrigin:"Axel Springer",
        live:"https://www.bild.de/ig/2161471a-046b-486a-a4e7-9aded82ff89a/index/index.html#/m/live",
        livePred:"https://www.bild.de/ig/2161471a-046b-486a-a4e7-9aded82ff89a/index/index.html#/m/pred",
    },
    {
        id:4,
        name:"Bundestagswahl Coverage - Bar Chart",
        description:"Live bar-chart coverage module for Bundestagswahl results.",
        imageName:"btw-b.png",
        projectOrigin:"Axel Springer",
        live:"https://www.bild.de/ig/2161471a-046b-486a-a4e7-9aded82ff89a/index/index.html#/b/live",
    },
    {
        id:5,
        name:"Bundestagswahl Coverage - Seat Chart",
        description:"Bundestag-style seat projection chart for live Bundestag formation updates and gamification for custom coalition.",
        imageName:"btw-p.png",
        projectOrigin:"Axel Springer",
        live:"https://www.bild.de/ig/2161471a-046b-486a-a4e7-9aded82ff89a/index/index.html#/p/k/live",
    },
    {
        id:6,
        name:"Daily Horoscope",
        description:"Daily horoscope user-facing experience shipped at Axel Springer / BILD.",
        imageName:"horo.png",
        projectOrigin:"Axel Springer",
        live:"https://www.bild.de/ig/3a07efb1-176f-4a2d-8aaa-7e5310a0826f/index/index.html",
    },
    {
        id:7,
        name:"Portfolio Website",
        description:"Personal portfolio showcasing projects and skills, built with React and styled using Tailwind CSS for a modern, responsive design.",
        image:projectPF,
        projectOrigin:"Personal",
        github:"https://github.com/RBCodewalker/portfolio",
        live:"https://rajdeepbastakoti.com/",
    }, 
    // {
    //     id:8,
    //     name:"Doctors Hub",
    //     description:"Healthcare platform built with NextJS and TypeScript featuring REST API integration and infinite scrolling for seamless browsing of medical professionals.",
    //     image:projectDH,
    //     projectOrigin:"Personal",
    //     github:"https://github.com/RBCodewalker/doctors-hub",
    //     live:"https://doctors-hub.vercel.app/",
    // },
]
